module.exports = __webpack_public_path__ + "static/img/7.1168754.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/7.png
// module id = eLMo
// module chunks = 0